/**
 * Coup de pouce — Attendu 1092 « opposé d'un nombre, somme des opposés »
 * (automatisme 4e, l. 633). UNE page STATIQUE partagée par les trois
 * generator_keys.
 *
 * L'image que l'élève a déjà : la droite symétrique de 703 (5e, « distance à
 * zéro »). Un seul exemple, sacrifié : 6 et −6. Deux arcs de la même
 * longueur depuis 0, un vers la gauche jusqu'à −6, un vers la droite jusqu'à
 * 6 ; le résultat en gros « l'opposé de 6, c'est −6 » ; deux lignes en
 * langue d'élève : « −6 et 6 sont à la même distance de 0, chacun de son
 * côté. » et « −6 + 6 = 0 : je pars de −6, j'avance de 6, je suis à 0. »
 * (le même geste que la fiche de 1091).
 *
 * SACRIFIÉ : 6 et −6 ne s'affichent sur aucune carte (gen_1092, SACRIFIE,
 * auto-testé par gen1092.self.test.js).
 * Largeur bornée à 340 px, tailles de 1048, aria-label complet.
 */

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';

const X0 = 40;
const PAS = 22.8;
const Y = 100;
const toX = (n) => X0 + (n + 7) * PAS;

const GRADUATIONS = Array.from({ length: 15 }, (_, k) => {
    const n = k - 7;
    const x = toX(n);
    return `<line x1="${x}" y1="${Y - 6}" x2="${x}" y2="${Y + 6}" stroke="${ENCRE}" stroke-width="${n === 0 ? 2.2 : 1.2}"/>
  <text x="${x}" y="${Y + 22}" font-size="10" text-anchor="middle" fill="${ENCRE}">${n < 0 ? `−${-n}` : n}</text>`;
}).join('\n  ');

const arc = (de, a, couleur) => `<path d="M ${toX(de)} ${Y - 10} Q ${(toX(de) + toX(a)) / 2} ${Y - 58} ${toX(a)} ${Y - 10}" fill="none" stroke="${couleur}" stroke-width="2.4"/>`;

const SVG_OPPOSES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 226" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="Une droite graduée de moins 7 à 7. Deux arcs de la même longueur partent de 0 : un bleu vers la gauche jusqu'à moins 6, un orange vers la droite jusqu'à 6, chacun marqué 6. L'opposé de 6, c'est moins 6. Moins 6 et 6 sont à la même distance de 0, de chaque côté. Moins 6 plus 6 égale 0 : de moins 6, j'avance de 6, j'arrive à 0.">
  <line x1="${X0 - 12}" y1="${Y}" x2="${toX(7) + 14}" y2="${Y}" stroke="${ENCRE}" stroke-width="2"/>
  <polygon points="${toX(7) + 22},${Y} ${toX(7) + 12},${Y - 5} ${toX(7) + 12},${Y + 5}" fill="${ENCRE}"/>
  ${GRADUATIONS}

  <!-- deux arcs de 6 depuis 0, un de chaque côté -->
  ${arc(0, -6, BLEU)}
  ${arc(0, 6, ORANGE)}
  <text x="${toX(-3)}" y="${Y - 42}" font-size="13" font-weight="bold" text-anchor="middle" fill="${BLEU}">6</text>
  <text x="${toX(3)}" y="${Y - 42}" font-size="13" font-weight="bold" text-anchor="middle" fill="${ORANGE}">6</text>
  <circle cx="${toX(-6)}" cy="${Y}" r="6" fill="${BLEU}"/>
  <circle cx="${toX(6)}" cy="${Y}" r="6" fill="${ORANGE}"/>
  <circle cx="${toX(0)}" cy="${Y}" r="4" fill="${ENCRE}"/>

  <!-- le résultat et les deux lignes -->
  <text x="200" y="158" font-size="18" font-weight="bold" text-anchor="middle" fill="${ENCRE}">l'opposé de <tspan fill="${ORANGE}">6</tspan>, c'est <tspan fill="${BLEU}">−6</tspan></text>
  <text x="200" y="188" font-size="12" text-anchor="middle" fill="${ENCRE}"><tspan font-weight="bold" fill="${BLEU}">−6</tspan> et <tspan font-weight="bold" fill="${ORANGE}">6</tspan> sont à la même distance de 0, de chaque côté.</text>
  <text x="200" y="212" font-size="12" text-anchor="middle" fill="${ENCRE}"><tspan font-weight="bold">−6 + 6 = 0</tspan> : de −6, j'avance de 6, j'arrive à 0.</text>
</svg>`.trim();

const AIDE = { pages: [{ titre: 'À la même distance de 0', svg: SVG_OPPOSES }] };

const CP_1092 = {
    flash_texte_trou_saisie: AIDE,
    oppose_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1092;
